import Flex from "../../components/Flex"
import Screen from "./components/Screen"

import "./Legal.scss"
import { spacing } from "./styles"
import datasource from "../../datasource"

type Block = {
    subtitle?: string
    text?: string
    items?: string[]
}

type Section = {
    title: string
    blocks: Block[]
}

type LegalDoc = {
    title: string
    updated: string
    intro: string
    sections: Section[]
}

export default (props: { doc: "privacy" | "terms" }) => {

    const doc = datasource[props.doc] as LegalDoc

    return (
        <div className="legal">
            <Screen className="legal__screen">
                <Flex vertical gap={spacing("4xl")} className="legal__content">
                    <div className="legal__title">{doc.title}</div>
                    {doc.updated ? <div className="legal__updated">{doc.updated}</div> : null}
                    {doc.intro ? <div className="legal__intro">{doc.intro}</div> : null}
                    {doc.sections.map((section, i) => (
                        <Flex vertical gap={spacing("xl")} className="legal__section" key={i}>
                            <div className="legal__section__title">{section.title}</div>
                            {section.blocks.map((block, j) => (
                                <Flex vertical gap={spacing("md")} key={j}>
                                    {block.subtitle ? <div className="legal__block__subtitle">{block.subtitle}</div> : null}
                                    {block.text ? <div className="legal__block__text">{block.text}</div> : null}
                                    {block.items && block.items.length > 0 ? (
                                        <ul className="legal__block__list">
                                            {block.items.map((item, k) => <li key={k}>{item}</li>)}
                                        </ul>
                                    ) : null}
                                </Flex>
                            ))}
                        </Flex>
                    ))}
                </Flex>
            </Screen>
        </div>
    )
}
